<template>
    <div  :class="{ login: true, appRegister: flag == 'app' }">
        <div class="header">
            <span class="fl">新时代家谱</span>
            <a href="javascript:;" class="fr"  @click="goLogin()">立即登录</a>
        </div>
        <div id="admin"  :class="{ appWidth: flag == 'app' ,appClass:flag=='app'}"  style="width:450px;">
            <!-- v-loading="loading" -->
            <div class="pos">
                <h1 class="adminh1">用户注册</h1>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="手机号：" prop="pass">
                        <el-input prefix-icon="el-icon-user" placeholder="请输入您的手机号码" :class="{ appWidth:flag == 'app' }" style="width: 250px" type="text" v-model="ruleForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机验证码：" prop="mCode">
                        <el-input prefix-icon="el-icon-menu" :class="{ appWidth1:flag == 'app' }" style="width: 115px" type="text" v-model="ruleForm.mCode" autocomplete="off"></el-input>
                        <el-button type="primary" @click="getMobileCode()" style="margin-left:5px" >{{ codeMsg }}</el-button><!--  style="margin-left: 10px" -->
                        <!--  -->
                    </el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-input prefix-icon="el-icon-menu" :class="{ appWidth1:flag == 'app' }" style="width: 115px" type="text" v-model="ruleForm.code" autocomplete="off"></el-input>
                        <img :src="registerscr" alt="" @click="captcha('register')" />
                    </el-form-item>
                    <!-- <el-form-item label="姓名：" prop="name">
                        <el-input prefix-icon="el-icon-menu" placeholder="请输入您的姓氏" :class="{ appWidth1:flag == 'app' }" style="width: 115px" type="text" v-model="ruleForm.name1" autocomplete="off"></el-input>
                        <el-input prefix-icon="el-icon-menu" placeholder="请输入您的名字" :class="{ appWidth1:flag == 'app' }" style="width: 115px" type="text" v-model="ruleForm.name2" autocomplete="off"></el-input>
                    </el-form-item> -->
                    <el-form-item label="姓氏：" prop="name1">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 200px"
                            :class="{ appWidth:flag == 'app' }"
                            type="text"
                            v-model="ruleForm.name1"
                            placeholder="请输入您的姓氏"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="名字：" prop="name2">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 200px"
                            :class="{ appWidth:flag == 'app' }"
                            type="text"
                            v-model="ruleForm.name2"
                            placeholder="请输入您的名字"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                
                    <el-form-item label="性别：" prop="sex">
                        <el-radio-group v-model="ruleForm.sex" style="margin-top: 5px;">
                            <el-radio label="男">男</el-radio>
                            <el-radio label="女">女</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="地址：" prop="address">
                        <el-select v-model="sheng" @change="shengChage" placeholder="省" :class="{ appWidth2:flag == 'app' }" style="width:100px">
                            <el-option v-for="(item, index) in shengData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="shi" @change="shiChage" placeholder="市" :class="{ appWidth2:flag == 'app' }" style="width:100px;margin-top:10px">
                            <el-option v-for="(item, index) in shiData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-select
                            v-model="xian"
                            @change="xianChage"
                            v-if="inout == '1'"
                            placeholder="县/区"
                            :class="{ appWidth2:flag == 'app' }"
                            style="width:100px;margin-top:10px"
                        >
                            <el-option v-for="(item, index) in xianData" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <div style="position: relative;">
                            <!-- {{ propskey == "qs" ? "方位" : "自录地址" }} -->
                            <el-input
                                v-model="dizhi"
                                placeholder="点击选择自录地址"
                                style=" width: 80%; margin-top: 10px"
                                @keyup.enter.native="mapFun"
                            ></el-input>
                            <!-- @input="emit()" -->
                            <!-- :style="{ '': true, 'width:80%': flag == 'app', 'width:200px': flag == 'pc' }" -->
                            <a href="javascript:;" @click="mapOpen()" style=" color: #409EFF;display: block;">
                                <!-- {{ propskey == "qs" ? "点击选择方位" : "点击选择自录地址" }} -->
                                点击选择自录地址
                            </a>
                        </div>
                    </el-form-item>
                    <el-form-item label="密 码：" prop="checkPass">
                        <el-input
                            prefix-icon="el-icon-menu"
                            style="width: 250px"
                            :class="{ appWidth:flag == 'app' }" 
                            placeholder="请输入密码8-12位"
                            show-password
                            type="password"
                            v-model="ruleForm.checkPass"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item :class="{ appMargin:flag == 'app' }" >
                        <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
                        <el-button v-if="flag == 'app'" @click="goLogin()">立即登录</el-button>
                        <el-button v-if="flag == 'pc'" @click="goLogin()">返回</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-dialog title="手机短信验证码" :visible.sync="dialogVisible" :width=widthA>
            <span>
                <el-input prefix-icon="el-icon-menu" style="width: 115px" type="text" v-model="mobileCode" autocomplete="off"></el-input>
                <img :src="sendmsgscr" alt="" @click="captcha('sendmsg')" style="vertical-align: top" />
            </span>
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="getCode()">确定</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog  :class="{ appDiaWidth:flag == 'app' }" :visible.sync="dialogMap" width="500" class="map">
            <vmap @getLnglat="getPosi" :data="dtdz" :dzData="dizhi"></vmap>
        </el-dialog>
    </div>
</template>

<script>
import api from "@/request/api";
import vmap from "@/components/vmap.vue";

export default {
    name: "register",
    data() {
        /*
            mobile 手机号
            msgcode  手机验证码
            code  图形验证码
            familyName 姓
            givenName 名
            password 密码
        */
        //     mobile: "",
        //     password: "",
        //     code: "",
        //     msgcode: "",
        //     familyName: "",
        //     givenName: "",
        //     imgsrc: ""
        // };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输手机号"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value.length < 8) {
                callback(new Error('密码长度至少8位'));
            } else if (value.length > 20) {
                callback(new Error('密码长度不能超过20位'));
            } else if (!/[a-zA-Z]/.test(value)) {
                callback(new Error('密码必须包含字母'));
            } else if (!/[0-9]/.test(value)) {
                callback(new Error('密码必须包含数字'));
            } else{
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                callback();
            }
        };
        var validateName = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        var validateName1 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入姓氏"));
            } else {
                callback();
            }
        };
        var validateName2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入名字"));
            } else {
                callback();
            }
        };
        return {
            widthA:'30%',
            loading: false,
            registerscr: "",
            sendmsgscr: "",
            ruleForm: {
                pass: "",
                checkPass: "",
                code: "",
                name: "",
                name1: "",
                name2: "",
                sex: "男",
            },
            rules: {
                pass: [{ validator: validatePass, trigger: "blur" }],
                checkPass: [{ validator: validatePass2, trigger: "blur" }],
                code: [{ validator: validateCode, trigger: "blur" }],
                name: [{ validator: validateName, trigger: "blur" }],
                name1: [{ validator: validateName1, trigger: "blur" }],
                name2: [{ validator: validateName2, trigger: "blur" }],
            },
            countdown: 60,
            //按钮上的文字
            codeMsg: "获取验证码",
            mobileCode: "",
            //定时器
            timer: null,
            dialogVisible: false,

            inout: 1,
            shengData: [],
            shiData: [],
            xianData: [],
            sheng: "",
            shi: "",
            xian: "",
            zhen: "",
            dizhi: "",
            dialogMap: false,
            dtdz: "",
            flag: "pc"
        };
    },
    components: {
        vmap
    },
    mounted() {
        this.flag = sessionStorage.getItem("flag");
        console.log(this.flag,'--this.flag');
        if(this.flag=='app'){
            this.widthA='90%'//手机验证码弹窗大小
        }else{
            this.widthA='30%'
        }
        this.captcha("register");
        this.captcha("sendmsg");
        this.getSheng();
    },
    methods: {
        // register() {
        //     api.register(
        //         JSON.stringify({
        //             mobile: this.mobile,
        //             password: this.password,
        //             code: this.code,
        //             msgcode: this.msgcode,
        //             familyName: this.familyName,
        //             givenName: this.givenName
        //         })
        //     ).then((res) => {
        //         console.log(res);
        //     });
        // },
        submitForm(formName) {
            this.loading = true;
            api.register({
                mobile: this.ruleForm.pass,
                password: this.ruleForm.checkPass,
                code: this.ruleForm.code,
                msgcode: this.ruleForm.mCode,
                name: this.ruleForm.name1+this.ruleForm.name2,
                sex: this.ruleForm.sex,
                address: this.ruleForm.address,
                sheng: this.shengName,
                shi: this.shiName,
                xian: this.xianName,
                address: this.dizhi,
            }).then((res) => {
                this.loading = false;
                if (res.code == 0) {
                    this.$message({
                        message: "注册成功",
                        type: "success"
                    });
                    setTimeout(() => {
                        this.$router.push("/");
                        this.loading = false;
                    }, 1000);
                } else {
                    this.captcha();
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        },
        goLogin(){
            this.$router.push("/");
        },
        captcha(type) {
            api.captcha(type).then((res) => {
                this[type + "scr"] = res.data;
            });
        },
        // 获取手机验证码
        getMobileCode() {
            if (this.ruleForm.pass != "") {
                !this.timer ? (this.dialogVisible = true) : "";
            } else {
                this.$message({
                    message: "请输入手机号",
                    type: "warning"
                });
            }
        },
        getCode() {
            if (!this.timer) {
                api.sendmsg({
                    mobile: this.ruleForm.pass,
                    code: this.mobileCode,
                    type: 1
                }).then((res) => {
                    if (res.code == 0) {
                        this.setTime();
                        this.dialogVisible = false;
                        this.$message({
                            message: "发送成功",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            }
        },
        //倒计时
        setTime() {
            let _this = this;
            this.timer = setInterval(() => {
                if (_this.countdown > 0 && _this.countdown <= 60) {
                    _this.countdown--;
                    if (_this.countdown !== 0) {
                        _this.codeMsg = "重新发送(" + _this.countdown + ")";
                    } else {
                        clearInterval(_this.timer);
                        _this.codeMsg = "获取验证码";
                        _this.countdown = 60;
                        _this.timer = null;
                    }
                }
            }, 1000);
        },
        // 获取省
        getSheng() {
            api.getSheng(this.inout).then((res) => {
                this.shengData = res.data;
                this.sheng = "";
                for (let i = 0; i < res.data.length; i++) {
                    if (this.shengName == res.data[i].name) {
                        this.sheng = res.data[i].id;
                        this.shengName = res.data[i].name;
                        this.getShi();
                    }
                }
            });
        },
        // 获取市
        getShi() {
            // if (this.sheng != '' && this.inout!='') {
            if (
                this.sheng != "" &&
                this.sheng != undefined &&
                this.sheng != null &&
                this.inout != "" &&
                this.inout != undefined &&
                this.inout != null
            ) {
                api.getShi({ type: this.inout, id: this.sheng }).then((res) => {
                    this.shiData = res.data;
                    this.shi = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.shiName == res.data[i].name) {
                            this.shi = res.data[i].id;
                            this.shiName = res.data[i].name;
                            this.getXian();
                        }
                    }
                    // }
                });
            }
        },
        // 获取县/区
        getXian() {
            if (this.shi != "" && this.shi != undefined && this.shi != null) {
                api.getXian(this.shi).then((res) => {
                    this.xianData = res.data;
                    this.xian = "";
                    // if (this.data != undefined) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.xianName == res.data[i].name) {
                            this.xian = res.data[i].id;
                            this.xianName = res.data[i].name;
                        }
                    }
                    // }
                });
            }
        },
        shengChage(e) {
            for (const key in this.shengData) {
                if (this.shengData[key].id == e) {
                    this.shengName = this.shengData[key].name;
                    this.dizhi = this.shengName;
                }
            }
            this.shi = "";
            this.xian = "";
            this.getShi();
        },
        shiChage(e) {
            // this.shiData.forEach((item) => {
            //     if (item.id == e) {
            //         this.shiName = item.name;
            //         this.dizhi = this.shengName + this.shiName;
            //     }
            // });
            for (const key in this.shiData) {
                if (this.shiData[key].id == e) {
                    this.shiName = this.shiData[key].name;
                    this.dizhi = this.shengName + this.shiName;
                }
            }
            this.xian = "";
            this.getXian();

            this.getCoordinate();
        },
        xianChage(e) {
            // this.xianData.forEach((item) => {
            //     if (item.id == e) {
            //         this.xianName = item.name;
            //         this.dizhi = this.shengName + this.shiName + this.xianName;
            //     }
            // });
            for (const key in this.xianData) {
                if (this.xianData[key].id == e) {
                    this.xianName = this.xianData[key].name;
                    this.dizhi = this.shengName + this.shiName + this.xianName;
                }
            }
            this.getCoordinate();
        },
        getCoordinate() {
            if (this.sheng != "" && this.shi != "") {
                api.getCoordinate(
                    this.$qs.stringify({
                        type: this.inout,
                        sheng: this.shengName,
                        shi: this.shiName,
                        xian: this.xianName
                    })
                ).then((res) => {
                    this.dtdz = res.data;
                });
            }
        },
        //地图定位
        mapOpen() {
            this.dialogMap = true;
        },
        getPosi(lng, lat, address) {
            this.dtdz = lng + ", " + lat;
            this.dizhi = address;
            this.dialogMap = false;
            // this.$set(this.ruleForm, this.maKkey, );
            // this.$set(this.ruleForm, "czzdydz", address);
        }
    },
};
</script>
<style lang="less">
.login {
    width: 100%;
    height: 100%;
    background: url("../assets/img/bj_zhuce.jpg");
    .header {
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
    }

    #admin {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -350px;
        margin-left: -250px;
        width: 400px;
        height: auto;
        min-height: 400px;
        background: #fff;
        border-radius: 15px;
        border: 1px solid #f3f3f3;
    }
    .adminh1 {
        margin: 10px;
        font-size: 20px;
    }
}
.appRegister {
    #admin {
        width: 90% !important;
        margin: 0 !important;
        left: 5% !important;
        transform: translateY(-50%) !important;
        // border-radius:0px !important; 
        .appClass{
            overflow-y: scroll;height:80vh
        }
        .appWidth{
            width:90% !important;
        }
        .appWidth1{
            width:41% !important; 
        }
        .appWidth2{
            width:31% !important; 
            // width:30% !important; 
        }
        .appMargin{
            margin-top:20px;
        }
        .demo-ruleForm{
            .el-form-item{
                margin-bottom:10px !important;
                .el-form-item__error{
                    padding-top:0 !important;
                    margin-top:-8px;
                }
            }
        }
    }
    .appDiaWidth{//自选地址弹窗
        >div{
            width:100% !important;
            .el-vue-amap-container{
                .el-vue-search-box-container{
                     width:80% !important;
                 }
                span{
                    left:90% !important;
                    top:30px !important;
                    }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue